import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LinearProgress from "@mui/material/LinearProgress";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import Copyright from "./Copyright";
import { refreshTokenSetup } from "../utils/refreshToken";

export default function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [signinprogress, setSigninprogress] = useState(false);
  const [courseInProgress, setCourseInProgress] = useState(false);
  const [message, setMessage] = useState("");
  const [signedIn, setSignedIn] = useState(false);

  const navigate = useNavigate();

  const onEmailChange = (e) => setEmail(e.target.value);
  const onPasswordChange = (e) => setPassword(e.target.value);

  const login = async (e) => {
    e.preventDefault();
    setMessage(null);
    const credentials = { email, password };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_GATEWAY_URL}user/login`,
        credentials
      );
      if (response.status === 200) {
        localStorage.setItem("userInfo", JSON.stringify(response.data));
        setSignedIn(true);
      } else {
        setMessage(response.message);
      }
    } catch (err) {
      setMessage(
        "The email address and password you entered are incorrect. Please try again."
      );
    }
  };

  const exchangeToken = async (token) => {
    setSigninprogress(true);
    const headers = {
      headers: {
        oauthtoken: token,
        "x-api-key": process.env.REACT_APP_API_TOKEN_API_KEY,
      },
    };

    try {
      const resp = await axios(
        `${process.env.REACT_APP_API_GATEWAY_URL}app/v1/token`,
        headers
      );
      setSigninprogress(false);
      setCourseInProgress(true);
      const ses = {
        token: resp.headers["x-marvelapi-token"],
        firstName: resp.data.fn,
        lastName: resp.data.ln,
      };

      const mycourseUrl = `${process.env.REACT_APP_API_GATEWAY_URL}app/v1/courses`;
      const courses = await axios(mycourseUrl, {
        headers: { Authorization: ses.token },
      });

      setCourseInProgress(false);
      ses.mycourses = courses.data;
      localStorage.setItem("userInfo", JSON.stringify(ses));
      setSignedIn(true);
    } catch (error) {
      console.error("Error exchanging token:", error);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      {signedIn ? navigate("/coursepage") : null}
      <CssBaseline />
      {signinprogress ? (
        <Box sx={{ mt: 4, textAlign: "center" }}>
          <Typography>
            {courseInProgress ? "Getting your courses..." : "Signing in..."}
          </Typography>
          <LinearProgress color="secondary" />
        </Box>
      ) : (
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box sx={{ mt: 2 }}>
            <GoogleOAuthProvider
              clientId={process.env.REACT_APP_GOOGLE_OATH_CLIENT_ID}
            >
              <GoogleLogin
                onSuccess={(credentialResponse) => {
                  setSigninprogress(true);
                  exchangeToken(credentialResponse.credential);
                }}
                onError={() => {
                  console.log("Login Failed");
                }}
              />
            </GoogleOAuthProvider>
          </Box>
        </Box>
      )}
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}
